<template>
    <m-dialog :show="show" @update:show="s => $emit('update:show', s)" heading="Forgotten your password?">
        <div class="p-2">
            <p>Enter your details below and click send to receive instructions per email to reset your password.</p>
            <m-label text="Name" :error="$v.name.$error ? 'Name is required' : ''">
                <m-text class="w-full" v-model="name" @enter="forgetPassword()"></m-text>
            </m-label>
            <m-label text="Contact Number" :error="$v.contact.$error ? 'Contact number is required' : ''">
                <m-text class="w-full" v-model="contact" @enter="forgetPassword()"></m-text>
            </m-label>
            <m-label text="Email" :error="$v.email.$error ? 'Email address invalid' : ''">
                <m-text class="w-full" v-model="email" @enter="forgetPassword()"></m-text>
            </m-label>
            <m-label text="Company Name" :error="$v.company.$error ? 'Company name is required' : ''">
                <m-text class="w-full" v-model="company" @enter="forgetPassword()"></m-text>
            </m-label>
            <m-label text="Comments">
                <m-textarea class="w-full" v-model="comments" @enter="forgetPassword()"></m-textarea>
            </m-label>
        </div>
        <template slot="footer">
            <div class="btn btn-error mr-2" @click="$emit('update:show', false)">Cancel</div>
            <div class="btn btn-success" @click="forgetPassword()">Submit</div>
        </template>
    </m-dialog>
</template>
<script>
import Ajax from '../js/ajax.js'
import {required, email} from 'vuelidate/lib/validators'
import Share from '@/share.js'

export default {
    props: {
        show: Boolean
    },
    data() {
        return {
            name: '',
            contact: '',
            email: '',
            company: '',
            comments: ''
        }
    },
    validations: {
        name: {required},
        contact: {required},
        email: {required, email},
        company: {required},
    },
    methods: {
        forgetPassword() {
            this.$v.$touch()
            if (this.$v.$invalid) {
                return
            }
            Ajax.post('/auth/forgotpassword', {
                name: this.name,
                contact: this.contact,
                company: this.company,
                comments: this.comments,
                email: this.email
            }).then(data => {
                if (data) {
                    Share.showSnack('Password instructions has been sent to your email')
                } else {
                    Share.showSnack('We could not verify your details. MarisIT will contact you.')
                }
                this.$emit('update:show', false)
            }).catch((e) => {
                this.$emit('update:show', false)
                Sentry.captureMessage(e);
            })
        },
    }
}
</script>